import React, { useContext, useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import LoginModal      from './components/LoginModal';
import LoginPage       from './pages/LoginPage';
import AdminPage       from './pages/AdminPage';
import Dashboard       from './pages/Dashboard';
import PublicQueryPage from './pages/PublicQueryPage';
import FilterPage      from './pages/FilterPage';
import Header          from './components/Header';
import StatsPage       from './pages/StatsPage';

import { IdleLogoutHandler } from './hooks/IdleLogoutHandler';
import { AuthProvider, AuthCtx } from './context/AuthContext';
import SessionsPage from './pages/SessionsPage';
import VerifyEmail from './pages/VerifyEmail';
import VerifyResult from './pages/VerifyResult';

import ResetPasswordPage from './pages/ResetPasswordPage';
import MantenimientoPage from './pages/MantenimientoPage';

import { api }     from './services/api';
import { useLocation, useNavigate  } from 'react-router-dom';
const hideModalOn = ['/verificar-email', '/verificado', '/reset', '/login'];

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export function AppRoutes() {
  const { token, setToken  } = useContext(AuthCtx);           // cliente
  const location    = useLocation();          // 👈
  const navigate    = useNavigate(); 
  const path        = location.pathname;
  /*const [admin, setAdmin] = useState(
    !!localStorage.getItem('adminToken'),
  );*/

  const [admin, setAdmin] = useState(false); // Inicialmente no es admin


  useEffect(() => {
    const bye = () => {
      const t = localStorage.getItem('clientToken');
      if (t) {
        navigator.sendBeacon('/api/clientes/logout-beacon',
          new Blob([],{
            type   :'application/json',
            headers:{ Authorization:`Bearer ${t}` }
          })
        );
      }
    };
    window.addEventListener('visibilitychange', bye);
    return () => window.removeEventListener('visibilitychange', bye);
  }, []);


  const handleAdminLoginSuccess = (jwt) => {
    localStorage.setItem('adminToken', jwt);
    setAdmin(true);
    setToken(jwt); // Actualiza el token en el contexto
    navigate('/admin'); // Solo para admins
  };

  return (
    <>
      <IdleLogoutHandler />

      {token && <Header />}

      {!token && !hideModalOn.includes(path) && <LoginModal />}

      {/* El modal sólo se monta si NO hay token }
      {/*!token && <LoginModal />*/}

      <Routes>
        {/* públicas */}
      {/*  luego revertir esto:  <Route path="/"          element={<FilterPage />} />*/  }  
      <Route path="/"          element={<FilterPage />} />
 {/*<Route path="/" element={<MantenimientoPage />} />*/  } 

        <Route path="/consulta"  element={ token ? <PublicQueryPage /> : <Navigate to="/" replace /> } />
        <Route path="/dashboard" element={ token ? <Dashboard       /> : <Navigate to="/" replace /> } />
        <Route path="/verificar-email" element={<VerifyEmail />} />
        <Route path="/verificado" element={<VerifyResult />} />
        <Route path="/reset" element={<ResetPasswordPage />} />

        
        {/* admin */}
        <Route path="/login" element={<LoginPage onLogin={handleAdminLoginSuccess} />} />

        <Route path="/admin"
          element={ admin ? <AdminPage /> : <Navigate to="/login" replace /> }
        />
        <Route path="/admin/stats"
          element={ admin ? <StatsPage /> : <Navigate to="/login" replace /> }
        />

<Route
  path="/admin/sesiones"
  element={ admin ? <SessionsPage /> : <Navigate to="/login" replace /> }
/>

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
